var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"hideInside":false,"state":true}},[_c('div',{staticClass:"auth"},[_vm._v(" Ожидание авторизации... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }